<template>
  <div ref="chartWrapper"
       class="widget-wrapper padT0 padB0"
  >
    <div class="widget-contents">
      <div class="widget-contents-wrapper">
        <non-trend-chart ref="chartInstance"
                     class="widget-contents-chart"
                     :type="opts.chartType"
                     :x-axis="xAxis"
                     :y-axis="yAxis"
                     :tooltip="toolTip"
                     :data="widgetData"
                     :series-options="seriesOptions"
        />
      </div>
    </div>
  </div>
</template>
<script>
import {widgetMixin} from '~/mixins/widgetCommonMixin'

import {createNamespacedHelpers} from 'vuex'
const {mapActions} = createNamespacedHelpers('dashboard/dashboard')

export default {
  name: 'widgetSecAptMalFileTopn',
  mixins: [widgetMixin],
  data () {
    return {
      w: 1,
      self: this,
      opts: {
        chartType: 'bar'
      },
      title: 'widgetSecAptMalFileTopn',
      isLock: false,
      isMove: true,
      isResize: true,
      eventBus: true,
      deviceType: [21],
      restData: {
        result: [],
        unit_time: ''
      },
      seriesOptions: {
        barWidth: '40%'
      },
      widgetData: []
    }
  },
  computed: {
    xAxis () {
      const xAxisOptions = {}

      if (this.opts.chartType === 'bar') {
        xAxisOptions.axisLabel = {
          formatter: (value) => {
            return `${this.kmgtConverter(value)}`
          }
        }
      }

      return xAxisOptions
    },
    yAxis () {
      const yAxisOptions = {}

      if (this.opts.chartType === 'column') {
        yAxisOptions.axisLabel = {
          formatter: (value) => {
            return `${this.kmgtConverter(value)}`
          }
        }
      }

      return yAxisOptions
    },
    toolTip () {
      return {
        formatter: (params) => {
          const {name, value, marker} = _.isArray(params) ? params[0] : params
          return `${marker} ${name} : <b>${this.separateByComma(value)}${this.restData.unit_time}</b>`
        }
      }
    },
    widgetChartMenu () {
      return [
        {
          icon: 'icon-chart-pie',
          label: 'Pie Chart',
          value: 'pie'
        },
        {
          icon: 'icon-chart-bar',
          label: 'Bar Chart',
          value: 'bar'
        },
        {
          icon: 'icon-chart-column',
          label: 'Column Chart',
          value: 'column'
        },
        {
          icon: 'icon-chart-tree-map',
          label: 'Tree Map',
          value: 'treemap'
        }
      ]
    }
  },
  beforeDestroy () {
    this.self = null
  },
  methods: {
    ...mapActions([
      'getWidgetData'
    ]),
    // 위젯 대상 장비 필터 설정.
    async onChangeWidgetMachId ({ machId }) {
      // 위젯 옵션 변경 - 저장에 필요한 값???
      this.opts.mach_id = machId
      this.getWidgetContentsData(true, machId)
    },
    async getWidgetContentsData (init = false, extraParams = null) {
      const contentsOptions = {
        widgetType: 'apt_mal_file_top'
      }

      // Progress 출력 여부
      this.showProgress(true)

      // initFlag가 True면 기존 차트 데이터 초기
      if (init) {
        // 위젯 데이터 초기화
        this.widgetData = []

        // Series 초기화
        this.$refs.chartInstance.clear()
      }

      if (this.opts.haMember) {
        contentsOptions.dataType = this.opts.haMember
      }

      // 장비 filter 추가
      if (this.opts.mach_id) {
        contentsOptions.machId = this.opts.mach_id
      }

      // 엑스트라 파라미터가 있는 경우 (IP Type 또는 HA Mamber/Device Filter를 선택하여 데이터를 다시 불러와야 하는 경우)
      if (extraParams) {
        if (extraParams.haMember) {
          contentsOptions.dataType = extraParams.haMember
        }

        if (extraParams.machId) {
          contentsOptions.machId = extraParams.machId
        }
      }

      // API 호출
      const {code, result} = await this.getWidgetData(contentsOptions)

      // Series 데이터 구성
      if (code === 'ok') {
        this.restData = result

        if (this.restData.result) {
          const maliciousFiles = []

          for (const { name: fileType, value: count } of this.restData.result) {
            maliciousFiles.push({
              name: fileType,
              value: count
            })
          }

          this.widgetData = maliciousFiles
        }
      }

      // Progress 출력 여부
      this.showProgress(false)
    }
  },
  watch: {}
}
</script>

<style scoped>
</style>
